import React from 'react'

const About = () => {
  return (
    <div>
      <p>Halaman About</p>
    </div>
  )
}

export default About
